import React from "react";
import Icon from "~/assets/icons/Icon";
import Button from "~/components/Button";
import { CurrentStepProps } from "../getSideMenuItems";
import { CloseDialog } from "../../CloseDialog";
import { getRoute } from "~/utils/getRoute";

type Props = CurrentStepProps & {
  onContinue: (options?: { shouldExitEditing?: boolean }) => void;
};

const ButtonGroup = (props: Props) => {
  const { isEditing, form, onContinue, onStepChange, isSubmitting } = props;
  const {
    formState: { isDirty },
  } = form;

  return (
    <div className={`flex flex-col md:flex-row gap-5`}>
      {!isEditing ? (
        <div className="flex flex-col w-full gap-4">
          <Button
            variant="primary"
            size="lg"
            className={"w-full"}
            onClick={() => onContinue()}
            disabled={isSubmitting}
          >
            Gem og fortsæt
          </Button>
          <CloseDialog
            buttonText="Fortsæt senere"
            confirmText="Fortsæt senere"
            bodyText='Dine ændringer på denne side vil blive kasseret, men dit produkt vil blive gemt som "Skjult".'
            backPath={getRoute("/backroom/products").pathname}
            hideIcon
            variant="primary-light"
            requiresConfirmation
          />
        </div>
      ) : (
        <>
          {isEditing && !isDirty ? (
            <>
              <Button
                variant="primary-light"
                size="lg"
                className="flex items-center gap-2.5 justify-center"
                onClick={() => onStepChange?.("previous")}
                disabled={isDirty}
              >
                <Icon name="arrowLeft" className="w-6 h-6" />
                Forrige
              </Button>

              <Button
                variant="primary-light"
                size="lg"
                className="flex items-center gap-2.5 justify-center"
                onClick={() => onStepChange?.("next")}
                disabled={isDirty}
              >
                Næste
                <Icon name="arrowRight" className="w-6 h-6" />
              </Button>
            </>
          ) : (
            <>
              <Button
                variant="primary"
                size="lg"
                onClick={() => onContinue()}
                disabled={!isDirty || isSubmitting}
              >
                Gem og næste
              </Button>
              <Button
                variant="primary"
                size="lg"
                onClick={() => onContinue({ shouldExitEditing: true })}
                disabled={!isDirty || isSubmitting}
              >
                Gem og afslut
              </Button>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default ButtonGroup;
